import OfferComp from "../components/offer_component/Offer";

const OfferP = () => {
    return ( 
        <>
        <OfferComp/>
        </>
     );
}
 
export default OfferP;